module.exports = __webpack_public_path__ + "static/media/marriageArticle2.4a5e9323.jpg";